
(function () {
  var CFG = window.NV_AI_CFG || {};
  var API = CFG.api;
  var EXAMPLES = CFG.examples || [];
  var EXAMPLES_LABEL = CFG.label || '';
  // modalità prova: aprire una volta il sito con ?ai-test=1 (si spegne con ?ai-test=0).
  // Le ricerche e i clic di questo browser non entrano nelle statistiche e non spostano la classifica.
  var TEST = (function () {
    try {
      var m = location.search.match(/[?&]ai-test=([01])/);
      if (m) { if (m[1] === '1') localStorage.setItem('nvAiTest', '1'); else localStorage.removeItem('nvAiTest'); }
      return localStorage.getItem('nvAiTest') === '1';
    } catch (e) { return false; }
  })();
  if (TEST && window.console) console.info('Ricerca AI: modalità prova attiva (statistiche escluse). Per spegnerla: ?ai-test=0');
  // collezioni del negozio [handle, titolo] per la nota "Collezione: … · Vedi tutta la collezione".
  // Lette qui dal tema (sempre aggiornate), senza passare dal server.
  var COLLS = [];
  // caricate solo alla prima apertura della ricerca (prima erano stampate in ogni pagina: ~10 KB e un ciclo su tutte le collezioni)
  var collsLoading = null;
  function loadColls() {
    if (collsLoading) return collsLoading;
    collsLoading = fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'collections/all?view=ai-colls')
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (list) { COLLS = Array.isArray(list) ? list : []; collIdx = null; })
      .catch(function () {});
    return collsLoading;
  }
  var root = document.getElementById('nv-ai');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var q = document.getElementById('nv-ai-q'), body = document.getElementById('nv-ai-body'),
      bar = document.getElementById('nv-ai-bar'), ac = document.getElementById('nv-ai-ac'),
      fileIn = document.getElementById('nv-ai-file');
  var money = function (v) { return v == null ? '' : v.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  // stella piena (titolo) e stella "a traccia" come le altre icone dell'header (22px, tratto 1.5)
  var STAR = '<svg viewBox="1.5 1 19 17.5" fill="currentColor" aria-hidden="true"><path d="M9 3.5Q10.5 9.5 16.5 11Q10.5 12.5 9 18.5Q7.5 12.5 1.5 11Q7.5 9.5 9 3.5Z"/><path d="M17.5 1Q18.05 3.45 20.5 4Q18.05 4.55 17.5 7Q16.95 4.55 14.5 4Q16.95 3.45 17.5 1Z"/></svg>';
  // ICONA DELL'HEADER (file "icon ai search novaliving.svg"): per cambiarla incolla qui un altro <svg> con fill/stroke="currentColor"
  var STAR_LINE = '<svg class="icon icon-ai-search" viewBox="5 7 100 100" width="22" height="22" fill="currentColor" aria-hidden="true" focusable="false"><path d="M47.19,17.38c1.73,0,3.12,1.4,3.12,3.12s-1.4,3.12-3.12,3.12c-17.26,0-31.25,13.99-31.25,31.25s13.99,31.25,31.25,31.25c14.85,0,27.29-10.36,30.46-24.25.39-1.68,2.07-2.73,3.75-2.35s2.73,2.06,2.35,3.74c-1.71,7.48-5.67,14.11-11.11,19.15l14.45,17.34c1.1,1.32.93,3.3-.4,4.4-1.32,1.1-3.29.93-4.4-.4l-14.58-17.5c-5.89,3.87-12.94,6.12-20.52,6.12-20.71,0-37.5-16.79-37.5-37.5S26.48,17.37,47.19,17.37h0Z"/><path d="M80.54,8.86c.21-1.14,1.85-1.14,2.05,0,1.5,8.62,8.250,15.37,16.87,16.87,1.14.2,1.14,1.84,0,2.04-8.62,1.5-15.37,8.25-16.87,16.87-.2,1.14-1.84,1.14-2.05,0-1.5-8.62-8.25-15.37-16.86-16.87-1.14-.2-1.14-1.84,0-2.04,8.62-1.5,15.36-8.25,16.86-16.87Z"/></svg>';
  var HEART = '<svg viewBox="0 0 25 25" fill="none" aria-hidden="true"><path d="M19.6706 5.4736C17.6806 3.8336 14.7206 4.1236 12.8906 5.9536L12.0006 6.8436L11.1106 5.9536C9.29063 4.1336 6.32064 3.8336 4.33064 5.4736C2.05064 7.3536 1.93063 10.7436 3.97063 12.7836L11.6406 20.4536C11.8406 20.6536 12.1506 20.6536 12.3506 20.4536L20.0206 12.7836C22.0706 10.7436 21.9506 7.3636 19.6706 5.4736Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  // ICONA "TROVA SIMILI": la stessa della Ricerca AI
  var SIMICON = STAR_LINE.replace(' class="icon icon-ai-search"', '');
  var LENS = '<svg viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><circle cx="11" cy="10" r="7"/><path d="m16 15 3 3" stroke-linecap="round"/></svg>';
  var wished = {}, reqId = 0, titleText = document.getElementById('nv-ai-title-text'), panel = root.querySelector('.nv-ai__panel');
  function setTitle(t) { titleText.textContent = t; }
  var CURRENT = null; // prodotto della pagina (solo nella scheda prodotto)
  var CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';

  // --- ricerche recenti e prodotti visti (restano solo nel browser del cliente) ---
  var LS = {
    get: function (k) { try { var v = JSON.parse(localStorage.getItem(k)); return Array.isArray(v) ? v : []; } catch (e) { return []; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  function addRecent(t) {
    var low = t.toLowerCase();
    LS.set('nvAiRecent', [t].concat(LS.get('nvAiRecent').filter(function (x) { return String(x).toLowerCase() !== low; })).slice(0, 5));
  }

  // --- tasto "indietro" del telefono/browser: chiude la finestra invece di lasciare la pagina ---
  var HIST = !!(window.history && history.pushState);
  function inAiState() { return HIST && history.state && history.state.nvAi; }
  function setAiState(extra) {
    if (!HIST) return;
    var st = { nvAi: 1 }; for (var k in (extra || {})) st[k] = extra[k];
    try { if (inAiState()) history.replaceState(st, ''); else history.pushState(st, ''); } catch (e) {}
  }

  function simButton(cls, attrs) {
    return '<button type="button" class="nv-ai__sim ' + (cls || '') + '" ' + (attrs || '') + ' aria-label="Trova simili"><span class="nv-ai__sim-ico">' + SIMICON + '</span><span class="nv-ai__sim-label">Trova simili</span></button>';
  }

  // --- Wishlist (Swym) ---
  function withSwat(fn) {
    if (window._swat) return fn(window._swat);
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(fn);
  }
  function toggleWish(btn, handle) {
    fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var v = (p.variants || [])[0] || {};
      var item = { epi: v.id, empi: p.id, du: location.origin + '/products/' + handle,
                   iu: p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '',
                   pr: (v.price || 0) / 100, dt: p.title, bt: p.vendor };
      withSwat(function (swat) {
        var adding = !wished[handle];
        var done = function () { wished[handle] = adding; btn.classList.toggle('is-active', adding); track(adding ? 'ai_wishlist_add' : 'ai_wishlist_remove', { handle: handle }); };
        try { if (adding) swat.addToWishList(item, done); else swat.removeFromWishList(item, done); }
        catch (e) { console.warn('Wishlist non disponibile', e); }
      });
    }).catch(function () {});
  }

  // --- apertura / chiusura (alla chiusura si riparte da zero) ---
  var hideTimer;
  function syncBar() { bar.classList.toggle('has-text', !!q.value); }
  function reset() {
    reqId++; acReq++; q.value = ''; syncBar(); closeAc(); closePop(); body.innerHTML = '';
    if (photo) { URL.revokeObjectURL(photo.url); photo = null; }
    root.classList.remove('has-results'); setTitle('Ricerca AI');
  }
  function open(noFocus) {
    loadColls();
    clearTimeout(hideTimer); placeUnderHeader();
    if (!inAiState()) setAiState();
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (!body.innerHTML) intro();
    typePlaceholder();
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-visible'); }); });
    if (noFocus !== true) setTimeout(function () { q.focus(); }, 60);
    warmUp();
  }
  function close(fromHistory) {
    if (fromHistory !== true && inAiState()) {
      history.back(); // il popstate richiama close(true)
      setTimeout(function () { if (root.classList.contains('is-visible')) close(true); }, 500);
      return;
    }
    root.classList.remove('is-visible'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    clearTimeout(phTimer); q.setAttribute('placeholder', PH_BASE);
    hideTimer = setTimeout(function () { root.classList.remove('is-open'); reset(); }, 260);
  }
  function intro() {
    root.classList.remove('has-results'); setTitle('Ricerca AI');
    var recent = LS.get('nvAiRecent'), viewed = LS.get('nvAiViewed').filter(function (v) { return v && v.h && v.h !== CURRENT; }), html = '';
    if (recent.length) html += '<div class="nv-ai__recent"><div class="nv-ai__recent-head"><p class="nv-ai__suggest-label"><strong>Ricerche recenti</strong></p><button type="button" class="nv-ai__linkbtn" data-clear-recent>Cancella</button></div><div class="nv-ai__suggest-list">' +
      recent.map(function (e) { return '<button type="button" class="nv-ai__ex" data-ex="' + esc(e) + '">' + CLOCK + '<span>' + esc(e) + '</span></button>'; }).join('') + '</div></div>';
    if (viewed.length) html += '<div class="nv-ai__viewed"><div class="nv-ai__recent-head"><p class="nv-ai__suggest-label"><strong>Visti di recente</strong></p><button type="button" class="nv-ai__linkbtn" data-clear-viewed>Cancella</button></div><div class="nv-ai__viewed-row">' +
      viewed.map(function (v) { return '<a class="nv-ai__vw" href="/products/' + encodeURIComponent(v.h) + '" title="' + esc(v.t) + '"><img loading="lazy" src="' + esc(v.i) + '" alt="' + esc(v.t) + '"></a>'; }).join('') + '</div></div>';
    // gli esempi non sono più un elenco: scorrono nel testo della barra (typePlaceholder)
    body.innerHTML = html;
  }
  // esempi di ricerca scritti e cancellati nella barra, come da tastiera (solo spunti, non cliccabili).
  // Si alternano con il testo di base; si fermano quando la finestra si chiude.
  var PH_BASE = q.getAttribute('placeholder') || '', phTimer = null;
  function typePlaceholder() {
    clearTimeout(phTimer);
    q.setAttribute('placeholder', PH_BASE);
    var list = (EXAMPLES || []).filter(function (e) { return e; });
    if (!list.length || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var seq = list.concat([PH_BASE]), i = 0, txt = PH_BASE, n = PH_BASE.length;
    function step(fn, ms) { phTimer = setTimeout(function () { if (root.classList.contains('is-open')) fn(); }, ms); }
    function erase() {
      if (n > 0) { n--; q.setAttribute('placeholder', txt.slice(0, n)); return step(erase, 22); }
      txt = seq[i]; i = (i + 1) % seq.length; step(type, 180);
    }
    function type() {
      if (n < txt.length) { n++; q.setAttribute('placeholder', txt.slice(0, n)); return step(type, 42 + Math.random() * 36); }
      step(erase, 2200);
    }
    step(erase, 1300);
  }
  // su mobile la finestra si apre esattamente sotto l'header
  function placeUnderHeader() {
    var h = document.querySelector('.shopify-section--header') || document.querySelector('header');
    var top = h ? Math.max(0, Math.ceil(h.getBoundingClientRect().bottom)) : 0;
    root.style.setProperty('--nv-ai-top', top + 'px');
  }
  window.addEventListener('resize', function () { if (root.classList.contains('is-open')) placeUnderHeader(); });
  function skeleton() {
    placeUnderHeader();
    root.classList.add('has-results');
    body.innerHTML = '<div class="nv-ai__grid">' + new Array(9).join('<div class="nv-ai__sk"></div>') + '</div>';
    body.scrollTop = 0; panel.scrollTop = 0; setTitle('Risultati della ricerca AI');
  }

  var warmed = false;
  function warmUp() { if (warmed) return; warmed = true; fetch(API + '/health').catch(function () {}); }

  function request(path, opts, attempt) {
    attempt = attempt || 0;
    if (TEST && path.indexOf('test=1') < 0) path += (path.indexOf('?') < 0 ? '?' : '&') + 'test=1';
    return fetch(API + path, opts).then(function (r) {
      return r.json().then(function (j) {
        if (r.status === 503 && attempt < 12) {
          return new Promise(function (res) { setTimeout(res, 5000); }).then(function () { return request(path, opts, attempt + 1); });
        }
        if (!r.ok) throw new Error((j.error && j.error.message) || 'Errore');
        return j;
      });
    });
  }

  // messaggio quando un filtro è stato allargato perché non c'era nulla
  function relaxNote(data) {
    var r = data.relaxed || [], f = data.filters || {};
    if (!r.length) return f.on_sale ? 'Prodotti in <strong>promozione</strong>' : (f.dims && f.dims.length ? 'Misure: <strong>' + dimsText(f.dims) + '</strong>' : '');
    // stanza + prodotto che in quella stanza non c'è ("divano ingresso")
    if (r.indexOf('ambiente') > -1 && data.room) return '<span>Nessun prodotto di questo tipo tra quelli per l\'ambiente <strong>' + esc(data.room.label) + '</strong>: ecco i più adatti.</span>';
    if (r.indexOf('categoria') > -1) return 'Al momento non abbiamo prodotti in questa categoria: ecco i più vicini a quello che cerchi.';
    if (r.indexOf('promozione') > -1) return 'Al momento non ci sono promozioni per questa ricerca: ecco i prodotti più adatti.';
    if (r.indexOf('brand') > -1) return 'Nessun prodotto di questo brand corrisponde alla ricerca: ecco i più vicini.';
    if (r.indexOf('misure') > -1) return 'Nessun prodotto con queste misure: ecco i più vicini.';
    if (r.indexOf('prezzo') > -1) return 'Nessun prodotto in questa fascia di prezzo: ecco i più vicini.';
    return 'Nessun prodotto disponibile subito: ecco i più vicini.';
  }

  function dimsText(list) {
    var NAMES = { w: 'larghezza', l: 'lunghezza', h: 'altezza', d: 'profondità', diam: 'diametro', any: '' };
    var OPS = { max: 'fino a ', min: 'almeno ', approx: 'circa ' };
    var labels = {};
    return list.map(function (c) {
      // persone/posti ("per 6 persone", "3 posti"): una sola etichetta al posto delle misure
      if (c.label) { if (labels[c.label]) return ''; labels[c.label] = 1; return esc(c.label); }
      return esc((NAMES[c.dim] ? NAMES[c.dim] + ' ' : '') + OPS[c.op] + String(Math.round(c.val * 10) / 10).replace('.', ',') + ' cm');
    }).filter(Boolean).join(', ');
  }

  // risultati: si mostrano 24 alla volta, gli altri arrivano scorrendo verso il basso
  var PAGE = 24, allRes = [], shown = 0, moreObs = null;
  function cardHtml(r) {
    return '<a class="nv-ai__card" href="/products/' + encodeURIComponent(r.handle) + '">' +
      '<div class="nv-ai__media"><div class="nv-ai__img"><img loading="lazy" src="' + esc(r.image_small) + '" alt="' + esc(r.title) + '"></div>' +
      '<button type="button" class="nv-ai__heart' + (wished[r.handle] ? ' is-active' : '') + '" data-wish="' + esc(r.handle) + '" aria-label="Aggiungi alla wishlist">' + HEART + '</button>' +
      simButton('', 'data-sim="' + esc(r.handle) + '" data-title="' + esc(r.title) + '"') + '</div>' +
      '<div class="nv-ai__info"><span class="nv-ai__t">' + esc(r.title) + '</span>' + (r.vendor ? '<span class="nv-ai__v">' + esc(r.vendor) + '</span>' : '') +
      (SHOW_SIZE && r.size ? '<span class="nv-ai__size">' + esc(r.size) + '</span>' : '') +
      '<div class="nv-ai__p"><span class="nv-ai__price' + (r.compare_at ? ' is-sale' : '') + '">' + money(r.price) + '</span>' + (r.compare_at ? '<s>' + money(r.compare_at) + '</s>' : '') + (r.available === false ? '<span class="nv-ai__soldout">Esaurito</span>' : '') + '</div></div></a>';
  }
  function showMore() {
    var grids = body.querySelectorAll('.nv-ai__grid'), more = body.querySelector('.nv-ai__more');
    if (!grids.length) return;
    var grid = grids[grids.length - 1];
    // prima i prodotti che corrispondono alla ricerca (match), poi "Potrebbe interessarti anche"
    allRes.slice(shown, shown + PAGE).forEach(function (r, k) {
      var i = shown + k;
      if (r.match === false && (i === 0 || allRes[i - 1].match !== false)) {
        var h = '<h3 class="nv-ai__also">' + (i ? 'Potrebbe interessarti anche' : 'Potrebbe interessarti') + '</h3>';
        if (i === 0) grid.insertAdjacentHTML('beforebegin', h);
        else { grid.insertAdjacentHTML('afterend', h + '<div class="nv-ai__grid"></div>'); grids = body.querySelectorAll('.nv-ai__grid'); grid = grids[grids.length - 1]; }
      }
      grid.insertAdjacentHTML('beforeend', cardHtml(r));
    });
    shown = Math.min(allRes.length, shown + PAGE);
    if (more && shown >= allRes.length) { if (moreObs) moreObs.disconnect(); more.remove(); }
  }

  // --- filtri, ordinamento e "affina" (sui risultati già trovati: istantanei) ---
  var base = [], fl = {}, SHOW_SIZE = false, lastQuery = '';
  var PRICES = [['0-100', 'Fino a 100 €'], ['100-300', '100 – 300 €'], ['300-600', '300 – 600 €'], ['600-1000', '600 – 1.000 €'], ['1000-', 'Oltre 1.000 €']];
  var MATS = ['legno', 'rovere', 'noce', 'metallo', 'ottone', 'acciaio', 'alluminio', 'vetro', 'ceramica', 'gres', 'marmo', 'travertino', 'pietra', 'velluto', 'bouclé', 'lino', 'cotone', 'lana', 'pelle', 'ecopelle', 'rattan', 'bambù', 'juta', 'midollino', 'terracotta', 'resina', 'teak', 'acacia', 'mango'];
  var ACCENTS = new RegExp('[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']', 'g'); // accenti (U+0300-U+036F)
  var fold = function (t) { return String(t || '').toLowerCase().normalize('NFD').replace(ACCENTS, ''); };
  var cap = function (t) { t = String(t || ''); return t.charAt(0).toUpperCase() + t.slice(1); };
  function matsOf(r) {
    if (!r._m && Array.isArray(r.mats)) r._m = r.mats; // materiali dai metafield (server)
    if (!r._m) { var t = ' ' + fold(r.title + ' ' + String(r.handle).replace(/-/g, ' ')) + ' '; r._m = MATS.filter(function (m) { return t.indexOf(' ' + fold(m)) > -1; }); }
    return r._m;
  }
  function priceIn(r, key) { var p = key.split('-'), lo = +p[0] || 0, hi = p[1] ? +p[1] : Infinity; return r.price != null && r.price >= lo && r.price <= hi; }
  function resetFl() { fl = { color: '', mat: '', price: '', vendor: '', sort: 'rel' }; }
  function flActive() { return !!(fl.color || fl.mat || fl.price || fl.vendor); }
  function filtered() {
    var list = base.filter(function (r) {
      return (!fl.vendor || r.vendor === fl.vendor) && (!fl.color || (r.colors || []).indexOf(fl.color) > -1) &&
        (!fl.price || priceIn(r, fl.price)) && (!fl.mat || matsOf(r).indexOf(fl.mat) > -1);
    });
    var pr = function (r) { return r.price == null ? Infinity : r.price; };
    // l'ordinamento vale dentro ogni gruppo: prima i prodotti cercati, poi "Potrebbe interessarti anche"
    var grp = function (r) { return r.match === false ? 1 : 0; };
    if (fl.sort === 'asc') list.sort(function (a, b) { return grp(a) - grp(b) || pr(a) - pr(b); });
    else if (fl.sort === 'desc') list.sort(function (a, b) { return grp(a) - grp(b) || (b.price || 0) - (a.price || 0); });
    else if (fl.sort === 'new') list.sort(function (a, b) { return grp(a) - grp(b) || String(b.created || '').localeCompare(String(a.created || '')); });
    return list;
  }
  function counter(fn) { var c = {}; base.forEach(function (r) { [].concat(fn(r) || []).forEach(function (k) { if (k) c[k] = (c[k] || 0) + 1; }); }); return c; }
  var CHEV = '<svg viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M1.5 3.5 5 7l3.5-3.5"/></svg>';
  var CHECK = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6.5 4.8 9 10 3"/></svg>';
  // riquadro con il valore scelto: al clic si apre la tendina (opzioni: [valore, nome, quanti])
  var DD = {};
  var EYE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg>';
  var EYE_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9.9 5.7A10 10 0 0 1 12 5.5c6.4 0 10 6.5 10 6.5a17 17 0 0 1-2.6 3.4M6.3 7.1C3.7 8.8 2 12 2 12s3.6 6.5 10 6.5a9.6 9.6 0 0 0 4.4-1"/><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/><path d="m3 3 18 18"/></svg>';
  function eyeHtml() {
    var hidden = root.classList.contains('is-compact');
    var t = hidden ? 'Mostra dettagli prodotto' : 'Nascondi dettagli prodotto';
    return '<button type="button" class="nv-ai__dd nv-ai__eye" data-eye aria-pressed="' + hidden + '" aria-label="' + t + '" title="' + t + '">' + (hidden ? EYE_OFF : EYE) + '</button>';
  }
  function dd(key, label, all, opts, cls) {
    if (opts.length < 2 && !fl[key]) return '';
    DD[key] = { label: label, opts: (all ? [['', all]] : []).concat(opts) };
    var cur = opts.filter(function (o) { return o[0] === fl[key]; })[0];
    var txt = key === 'sort' ? 'Ordina: ' + (cur ? cur[1] : opts[0][1]) : (cur ? cur[1] : label);
    return '<button type="button" class="nv-ai__dd' + (key !== 'sort' && fl[key] ? ' is-on' : '') + (cls ? ' ' + cls : '') + '" data-dd="' + key + '" aria-haspopup="listbox" aria-expanded="false" aria-label="' + esc(label) + '"><span>' + esc(txt) + '</span>' + CHEV + '</button>';
  }
  var pop = null, popBtn = null, popAt = 0;
  function closePop() {
    if (pop) { pop.remove(); pop = null; }
    if (popBtn) { popBtn.setAttribute('aria-expanded', 'false'); popBtn = null; }
  }
  function openPop(btn) {
    var key = btn.dataset.dd, d = DD[key];
    if (popBtn === btn) return closePop();
    closePop(); if (!d) return;
    popBtn = btn; popAt = Date.now(); btn.setAttribute('aria-expanded', 'true');
    pop = document.createElement('div');
    pop.className = 'nv-ai__pop'; pop.setAttribute('role', 'listbox'); pop.setAttribute('aria-label', d.label);
    var curV = key === 'sort' ? (fl.sort || 'rel') : (fl[key] || '');
    pop.innerHTML = d.opts.map(function (o) {
      var on = o[0] === curV;
      return '<button type="button" class="nv-ai__opt' + (on ? ' is-sel' : '') + '" role="option" aria-selected="' + on + '" data-opt="' + esc(o[0]) + '"><i>' + (on ? CHECK : '') + '</i><span>' + esc(o[1]) + '</span>' + (o[2] != null ? '<small>' + o[2] + '</small>' : '') + '</button>';
    }).join('');
    root.appendChild(pop);
    var r = btn.getBoundingClientRect(), w = Math.max(pop.offsetWidth, r.width), vw = document.documentElement.clientWidth;
    var left = btn.classList.contains('nv-ai__dd--sort') ? r.right - w : r.left;
    left = Math.max(8, Math.min(left, vw - w - 8));
    var top = r.bottom + 4, h = pop.offsetHeight;
    if (top + h > window.innerHeight - 8 && r.top - h - 4 > 8) top = r.top - h - 4;
    pop.style.left = left + 'px'; pop.style.top = top + 'px'; pop.style.minWidth = r.width + 'px';
    var sel = pop.querySelector('.is-sel') || pop.querySelector('.nv-ai__opt'); if (sel) sel.focus({ preventScroll: true });
  }
  function toolsHtml() {
    if (base.length < 4) return '';
    var byCount = function (c) { return Object.keys(c).sort(function (a, b) { return c[b] - c[a] || a.localeCompare(b); }); };
    var colc = counter(function (r) { return r.colors; }), mc = counter(matsOf), vc = counter(function (r) { return r.vendor; }), pc = {};
    PRICES.forEach(function (p) { pc[p[0]] = base.filter(function (r) { return priceIn(r, p[0]); }).length; });
    var shownN = filtered().length;
    return '<div class="nv-ai__tools"><div class="nv-ai__filters">' +
      '<span class="nv-ai__count">' + shownN + (shownN === 1 ? ' prodotto' : ' prodotti') + '</span>' +
      dd('color', 'Colore', 'Tutti i colori', byCount(colc).map(function (k) { return [k, cap(k), colc[k]]; })) +
      dd('mat', 'Materiale', 'Tutti i materiali', byCount(mc).map(function (k) { return [k, cap(k), mc[k]]; })) +
      dd('price', 'Prezzo', 'Tutti i prezzi', PRICES.filter(function (p) { return pc[p[0]]; }).map(function (p) { return [p[0], p[1], pc[p[0]]]; })) +
      dd('vendor', 'Brand', 'Tutti i brand', byCount(vc).map(function (k) { return [k, k, vc[k]]; })) +
      (flActive() ? '<button type="button" class="nv-ai__linkbtn nv-ai__linkbtn--reset" data-fl-reset>Azzera filtri</button>' : '') +
      dd('sort', 'Ordina', '', [['rel', 'Pertinenza'], ['asc', 'Prezzo crescente'], ['desc', 'Prezzo decrescente'], ['new', 'Novità']], 'nv-ai__dd--sort') +
      eyeHtml() +
      '</div></div>';
  }
  function drawResults() {
    closePop();
    if (moreObs) { moreObs.disconnect(); moreObs = null; }
    var box = body.querySelector('.nv-ai__results'), tools = body.querySelector('.nv-ai__tools');
    if (tools) tools.outerHTML = toolsHtml();
    allRes = filtered(); shown = 0;
    if (!allRes.length) { box.innerHTML = '<p class="nv-ai__msg">Nessun prodotto con questi filtri. <button type="button" class="nv-ai__linkbtn" data-fl-reset>Azzera filtri</button></p>'; return; }
    box.innerHTML = '<div class="nv-ai__grid"></div>' + (allRes.length > PAGE ? '<div class="nv-ai__more"><button type="button" class="button button--lg" data-more>Mostra altri prodotti</button></div>' : '');
    showMore();
    var more = box.querySelector('.nv-ai__more');
    if (more && 'IntersectionObserver' in window) {
      moreObs = new IntersectionObserver(function (en) { if (en[0].isIntersecting) showMore(); }, { rootMargin: '600px 0px' });
      moreObs.observe(more);
    }
  }
  function render(data, note, head) {
    var res = data.results || [], html = head || '';
    base = res; resetFl();
    SHOW_SIZE = !!(data.filters && data.filters.dims && data.filters.dims.length);
    // una riga sola: "Risultati per X. Cerca invece «…»  |  Collezione/Ambiente: Y · Vedi tutta la collezione"
    var info = [];
    // errore di battitura corretto dal server: si mostra la correzione e si può cercare la frase originale
    if (data.corrected && lastQuery) info.push('<span class="nv-ai__part"><span>Risultati per <strong>' + esc(data.corrected) + '</strong>.</span><button type="button" class="nv-ai__linkbtn" data-exact="' + esc(lastQuery) + '">Cerca invece «' + esc(lastQuery) + '»</button></span>');
    // stanza riconosciuta ("ingresso", "tappeto bagno"): link alla collezione della stanza
    if (data.room && (data.relaxed || []).indexOf('ambiente') < 0) info.push('<span class="nv-ai__part"><span>Ambiente: <strong>' + esc(data.room.label) + '</strong></span><span aria-hidden="true">·</span><a class="nv-ai__linkbtn" href="' + esc(data.room.url) + '">Vedi tutta la collezione</a></span>');
    // collezione cercata ("credenze", "mobili tv"): link alla collezione
    data.collection = matchCollection(data);
    if (data.collection && !data.room) info.push('<span class="nv-ai__part"><span>Collezione: <strong>' + esc(data.collection.title) + '</strong></span><span aria-hidden="true">·</span><a class="nv-ai__linkbtn" href="' + esc(data.collection.url) + '">Vedi tutta la collezione</a></span>');
    if (info.length) html += '<p class="nv-ai__note nv-ai__note--corr nv-ai__note--info">' + info.join('<span class="nv-ai__sep" aria-hidden="true">|</span>') + '</p>';
    note = note || relaxNote(data);
    // nessun prodotto con tutto quello che è stato chiesto (es. tavolo burgundy): lo diciamo
    if (!note && data.match_none && res.length && lastQuery) note = '<span>Nessun prodotto corrisponde esattamente a «<strong>' + esc(lastQuery) + '</strong>».</span>';
    if (note) html += '<p class="nv-ai__note">' + note + '</p>';
    // stanza: riga dei tipi di prodotto della stanza ("Tutto", "Consolle", "Scarpiere"...)
    if (data.room && data.room.types && data.room.types.length) html += roomTypesHtml(data);
    if (data.not_found) { if (moreObs) { moreObs.disconnect(); moreObs = null; } body.innerHTML = (data.collection ? '' : html) + notFoundHtml(data); track('ai_search_not_found', { search_term: lastQuery || '' }); return; }
    if (!res.length) { if (moreObs) { moreObs.disconnect(); moreObs = null; } body.innerHTML = html + '<p class="nv-ai__msg">Nessun prodotto trovato. Prova a descriverlo in un altro modo.</p>'; return; }
    body.innerHTML = html + toolsHtml() + '<div class="nv-ai__results"></div>';
    drawResults();
    track('ai_search_results', { count: res.length });
  }
  // collezione citata nella ricerca: tutte le parole del nome (singolare o plurale), una dopo l'altra.
  // Vince il nome più lungo; a parità quello uguale alla categoria cercata, poi più prodotti.
  var COLL_SKIP = ['all', 'frontpage', 'ambienti-della-casa', 'soggiorno', 'ingresso', 'sala-da-pranzo', 'camera-da-letto', 'bagno', 'cameretta-bambini', 'giardino'];
  var COLL_STOP = ['da', 'di', 'del', 'della', 'dei', 'delle', 'e', 'ed', 'per', 'in', 'con', 'il', 'lo', 'la', 'le', 'i', 'gli', 'un', 'una', 'a', 'al', 'alla', 'the', 'and', 'of'];
  function collTitle(t) { return String(t || '').replace(/\s*\|\s*novaliving\s*$/i, '').trim(); }
  function collStems(t) {
    return String(t || '').toLowerCase().replace(/&/g, ' e ').normalize('NFD').replace(ACCENTS, '')
      .split(/[^a-z0-9]+/).filter(function (w) { return w && COLL_STOP.indexOf(w) < 0; })
      .map(function (w) { return w.length > 3 && /[aeio]$/.test(w) ? w.slice(0, -1) : w; });
  }
  function hasSeq(seq, sub) {
    for (var i = 0; i + sub.length <= seq.length; i++) {
      var ok = true;
      for (var j = 0; j < sub.length; j++) if (seq[i + j] !== sub[j]) { ok = false; break; }
      if (ok) return true;
    }
    return false;
  }
  var collIdx = null;
  function matchCollection(data) {
    if (data.collection) return data.collection;
    if (data.room || !COLLS.length) return null;
    if (!collIdx) collIdx = COLLS.filter(function (c) { return c.length && COLL_SKIP.indexOf(c[0]) < 0; })
      .map(function (c) { return { h: c[0], t: collTitle(c[1]), n: c[2] || 0, s: collStems(collTitle(c[1])) }; })
      .filter(function (c) { return c.s.length; });
    var f = data.filters || {};
    var seqs = [lastQuery, data.corrected, f.text].filter(Boolean).map(collStems);
    var types = (f.types || []).map(function (t) { return collStems(t).join(' '); });
    var best = null, bk = null;
    collIdx.forEach(function (c) {
      // prima i nomi scritti nella ricerca, poi (solo se non ce ne sono) quelli uguali alla categoria
      var isType = types.indexOf(c.s.join(' ')) > -1, inText = seqs.some(function (s) { return hasSeq(s, c.s); });
      if (!isType && !inText) return;
      var k = [inText ? 1 : 0, c.s.length, isType ? 1 : 0, c.n];
      for (var i = 0; i < k.length; i++) { if (!bk || k[i] > bk[i]) { best = c; bk = k; break; } if (k[i] < bk[i]) break; }
    });
    return best ? { title: best.t, url: '/collections/' + best.h } : null;
  }
  function roomTypesHtml(data) {
    var on = (data.filters && data.filters.types) || [], any = false;
    var chips = data.room.types.map(function (t) {
      var act = on.indexOf(t.type) > -1; if (act) any = true;
      return '<button type="button" class="nv-ai__dd' + (act ? ' is-on' : '') + '" data-rq="' + esc(act ? data.room.all : t.q) + '" data-rt="' + esc(act ? 'tutto' : t.label) + '">' + esc(t.label) + '</button>';
    }).join('');
    return '<div class="nv-ai__rtypes" role="group" aria-label="Tipi di prodotto">' +
      '<button type="button" class="nv-ai__dd' + (any ? '' : ' is-on') + '" data-rq="' + esc(data.room.all) + '" data-rt="tutto">Tutto</button>' + chips + '</div>';
  }
  // prodotto che non vendiamo: nessun risultato (niente prodotti a caso) e qualche ricerca da provare
  function notFoundHtml(data) {
    // la ricerca è il nome di una collezione ("novità"): pulsante per aprirla
    if (data && data.collection) return '<div class="nv-ai__answer"><p class="nv-ai__answer-t">' + esc(data.collection.title) + '</p>' +
      '<p class="nv-ai__answer-p">Trovi tutti i prodotti nella collezione <strong>' + esc(data.collection.title) + '</strong>.</p>' +
      '<a class="button button--lg" href="' + esc(data.collection.url) + '">Vedi la collezione</a></div>';
    return '<p class="nv-ai__msg"><span class="nv-ai__msg-t">Nessun risultato per «' + esc(lastQuery || '') + '»</span>' +
      'Al momento non abbiamo prodotti che corrispondono alla tua ricerca. Prova a descriverlo con altre parole.</p>';
  }
  function refilter() {
    drawResults();
    var tools = body.querySelector('.nv-ai__tools');
    if (tools) { var top = tools.getBoundingClientRect().top - body.getBoundingClientRect().top; if (top < 0) body.scrollTop += top - 8; }
  }
  function fail(e) { var m = e && e.message && !/fetch|network|load/i.test(e.message) ? e.message : 'Ricerca non disponibile al momento, riprova tra poco.'; body.innerHTML = '<p class="nv-ai__msg">' + esc(m) + '</p>'; }
  function ticket() { var id = ++reqId; return function (fn) { return function (d) { if (id === reqId) fn(d); }; }; }

  // statistiche: ogni ricerca ha un codice (sid) e i clic sui risultati vengono segnalati al server
  var curSid = '';
  function beacon(type, handle, pos, qq, v, sid) {
    if (TEST) return;
    try {
      var b = JSON.stringify({ sid: sid == null ? curSid : sid, type: type, handle: handle || '', pos: pos || null, q: qq || '', v: v == null ? null : v });
      if (navigator.sendBeacon) navigator.sendBeacon(API + '/track', new Blob([b], { type: 'text/plain' }));
      else fetch(API + '/track', { method: 'POST', body: b, keepalive: true, headers: { 'Content-Type': 'text/plain' } });
    } catch (e) {}
  }
  function posOf(handle) { for (var i = 0; i < allRes.length; i++) if (allRes[i].handle === handle) return i + 1; return null; }
  function keepSid(d, extra) {
    curSid = d.sid || '';
    if (inAiState()) { var st = {}; for (var k in history.state) st[k] = history.state[k]; st.sid = curSid; try { history.replaceState(st, ''); } catch (e) {} }
  }
  // sid già noto (tornando indietro): la ricerca non viene contata due volte
  function again(sid) { return sid ? '&nolog=1&sid=' + encodeURIComponent(sid) : ''; }
  var FL_KEY = { color: 'colore', mat: 'materiale', price: 'prezzo', vendor: 'brand', sort: 'ordina' };

  // --- vendite dalla Ricerca AI ---
  // I prodotti aperti dai risultati restano 30 giorni nel browser del cliente (niente dati personali).
  // Quando il cliente aggiunge al carrello: se il prodotto era stato aperto dalla Ricerca AI si segnala
  // l'aggiunta al server, e il carrello riceve due attributi nascosti (iniziano con _) che finiscono
  // nell'ordine: cosi il gestionale conta ordini e fatturato arrivati dopo una ricerca AI.
  var ATT_KEY = 'nvAiAtt', ATT_DAYS = 30;
  function attGet() {
    try { var a = JSON.parse(localStorage.getItem(ATT_KEY)); if (a && a.t && Date.now() - a.t < ATT_DAYS * 864e5 && Array.isArray(a.h)) return a; } catch (e) {}
    return null;
  }
  function remember(handle) {
    if (!handle) return;
    var a = attGet() || { h: [] };
    a.h = [handle].concat(a.h.filter(function (x) { return x !== handle; })).slice(0, 20);
    a.t = Date.now(); if (curSid) a.s = curSid;
    try { localStorage.setItem(ATT_KEY, JSON.stringify(a)); } catch (e) {}
  }
  function onCartAdd(j) {
    var a = attGet(); if (!a) return;
    var items = (j && j.items) ? j.items : (j ? [j] : []);
    items.forEach(function (it) {
      if (it && it.handle && a.h.indexOf(it.handle) > -1) beacon('cart', it.handle, null, '', ((it.final_line_price != null ? it.final_line_price : it.line_price) || 0) / 100, a.s || '');
    });
    var root0 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    origFetch(root0 + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { '_ricerca_ai': a.s || 'si', '_ricerca_ai_prodotti': a.h.join(',') } }) }).catch(function () {});
  }
  var origFetch = window.fetch.bind(window);
  if (!window.__nvAiCartHook) {
    window.__nvAiCartHook = true;
    window.fetch = function (input, init) {
      var p = origFetch.apply(window, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && attGet()) {
          p.then(function (r) { if (r && r.ok) r.clone().json().then(onCartAdd).catch(function () {}); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  function searchText(text, sid, exact) {
    if (!text) return; closeAc(); skeleton(); track('ai_search', { search_term: text });
    lastQuery = text; addRecent(text); setAiState(exact ? { q: text, exact: 1 } : { q: text });
    var g = ticket();
    request('/search?limit=400&strict=1&q=' + encodeURIComponent(text) + (exact ? '&exact=1' : '') + again(sid)).then(g(function (d) {
      if (d.redirect) return go(d.redirect);
      if (d.answer) return renderAnswer(d.answer);
      keepSid(d); render(d);
    })).catch(g(fail));
  }
  // regola "Risposte" dell'admin: un riquadro di testo al posto dei prodotti (resi, newsletter, spedizioni...)
  function renderAnswer(a) {
    if (moreObs) { moreObs.disconnect(); moreObs = null; }
    base = []; allRes = [];
    // paragrafi (una riga = un paragrafo), **grassetto** e [link](/pagina) (il server lascia solo link del sito)
    var txt = String(a.text || '').split(/\n+/).map(function (par) {
      return '<p class="nv-ai__answer-p">' + esc(par)
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        .replace(/\[([^\]]+)\]\((\/[^)\s]*)\)/g, '<a href="$2">$1</a>') + '</p>';
    }).join('');
    body.innerHTML = '<div class="nv-ai__answer">' +
      (a.title ? '<p class="nv-ai__answer-t">' + esc(a.title) + '</p>' : '') +
      txt +
      (/^klaviyo:/.test(a.url || '') ? '<button type="button" class="button button--lg" data-klaviyo="' + esc(a.url.slice(8)) + '">' + esc(a.button || 'Iscriviti') + '</button>'
        : a.url ? '<a class="button button--lg" href="' + esc(a.url) + '">' + esc(a.button || 'Scopri di più') + '</a>' : '') +
      '</div>';
    track('ai_answer', { title: a.title || '', url: a.url || '' });
  }
  // regola "Reindirizzamenti" dell'admin: la ricerca porta a una pagina del sito (es. "reso" -> pagina resi).
  // La voce della cronologia smette di essere una ricerca, così tornando indietro non si rimbalza di nuovo.
  function go(url) {
    track('ai_redirect', { url: url });
    try { history.replaceState(null, ''); } catch (e) {}
    location.href = url;
  }
  function similar(handle, title, sid) {
    open(true); acReq++; clearTimeout(acTimer); q.value = ''; syncBar(); q.blur(); closeAc(); skeleton(); track('ai_similar', { handle: handle });
    lastQuery = ''; setAiState({ sim: handle, title: title });
    var g = ticket();
    request('/similar/' + encodeURIComponent(handle) + '?limit=48' + again(sid)).then(g(function (d) { keepSid(d); render(d, 'Prodotti simili a <strong>' + esc(title) + '</strong>'); })).catch(g(fail));
  }
  // --- ricerca con foto: la foto resta sopra i risultati e con il riquadro si sceglie l'oggetto ---
  var photo = null, cropTimer, drag = null;
  function loadPhoto(file) {
    return new Promise(function (resolve, reject) {
      var img = new Image(), src = URL.createObjectURL(file);
      img.onload = function () {
        var s = Math.min(1, 1024 / Math.max(img.width, img.height)), c = document.createElement('canvas');
        c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height); URL.revokeObjectURL(src);
        c.toBlob(function (b) { b ? resolve({ canvas: c, url: URL.createObjectURL(b), box: { x: 0, y: 0, w: 1, h: 1 } }) : reject(new Error('Immagine non valida')); }, 'image/jpeg', 0.9);
      };
      img.onerror = function () { URL.revokeObjectURL(src); reject(new Error('Immagine non valida')); };
      img.src = src;
    });
  }
  // solo la parte dentro il riquadro, al massimo 512 px (come prima)
  function cropBlob() {
    var c = photo.canvas, b = photo.box;
    var sx = Math.round(b.x * c.width), sy = Math.round(b.y * c.height),
        sw = Math.max(1, Math.round(b.w * c.width)), sh = Math.max(1, Math.round(b.h * c.height));
    var k = Math.min(1, 512 / Math.max(sw, sh)), o = document.createElement('canvas');
    o.width = Math.max(1, Math.round(sw * k)); o.height = Math.max(1, Math.round(sh * k));
    o.getContext('2d').drawImage(c, sx, sy, sw, sh, 0, 0, o.width, o.height);
    return new Promise(function (resolve, reject) { o.toBlob(function (bl) { bl ? resolve(bl) : reject(new Error('Immagine non valida')); }, 'image/jpeg', 0.88); });
  }
  var pct = function (v) { return (Math.round(v * 10000) / 100) + '%'; };
  function boxStyle(b) { return 'left:' + pct(b.x) + ';top:' + pct(b.y) + ';width:' + pct(b.w) + ';height:' + pct(b.h); }
  function photoHtml() {
    var b = photo.box, whole = b.x < 0.01 && b.y < 0.01 && b.w > 0.98 && b.h > 0.98;
    return '<div class="nv-ai__photo"><div class="nv-ai__crop" data-crop><img src="' + photo.url + '" alt="La tua foto" draggable="false">' +
      '<div class="nv-ai__crop-box" style="' + boxStyle(b) + '"><i data-h="nw"></i><i data-h="ne"></i><i data-h="sw"></i><i data-h="se"></i></div></div>' +
      '<div class="nv-ai__photo-txt"><p><strong>Prodotti simili alla tua foto</strong></p><small>Sposta o ridimensiona il riquadro per cercare un solo oggetto della foto.</small><div class="nv-ai__photo-links">' +
      (whole ? '' : '<button type="button" class="nv-ai__linkbtn" data-crop-reset>Usa tutta la foto</button>') +
      '<button type="button" class="nv-ai__linkbtn" data-photo-new>Cambia foto</button></div></div></div>';
  }
  function photoSearch(g) {
    return cropBlob().then(function (blob) {
      var fd = new FormData(); fd.append('file', blob, 'foto.jpg'); fd.append('q', q.value.trim()); fd.append('limit', '48');
      return request('/search/image', { method: 'POST', body: fd }).then(g(function (d) { keepSid(d); render(d, null, photoHtml()); }));
    });
  }
  function searchImage(file) {
    if (!file || !/^image\//.test(file.type || 'image/')) return;
    // il testo nella barra accompagna la foto solo se è stato scritto apposta, non se è la ricerca di prima
    if (q.value.trim() && q.value.trim() === lastQuery) { q.value = ''; syncBar(); }
    open(true); closeAc(); skeleton(); track('ai_search_image', {}); lastQuery = q.value.trim(); setAiState();
    var g = ticket();
    loadPhoto(file).then(function (p) {
      if (photo) URL.revokeObjectURL(photo.url);
      photo = p; return photoSearch(g);
    }).catch(g(fail));
  }
  // nuova ricerca dopo aver spostato il riquadro: la foto resta, i risultati si aggiornano
  function recrop() {
    var res = body.querySelector('.nv-ai__results'); if (res) res.classList.add('is-loading');
    track('ai_search_image_crop', {});
    var g = ticket();
    photoSearch(g).catch(g(fail));
  }
  var clamp = function (v, lo, hi) { return Math.max(lo == null ? 0 : lo, Math.min(hi == null ? 1 : hi, v)); };
  body.addEventListener('pointerdown', function (e) {
    var crop = e.target.closest('[data-crop]');
    if (!crop || !photo || (e.button && e.button > 0)) return;
    e.preventDefault();
    var r = crop.getBoundingClientRect(), b = photo.box, hnd = e.target.closest('[data-h]');
    var px = clamp((e.clientX - r.left) / r.width), py = clamp((e.clientY - r.top) / r.height);
    // con il riquadro su tutta la foto, trascinare disegna un riquadro nuovo (spostarlo non avrebbe senso)
    var inside = px >= b.x && px <= b.x + b.w && py >= b.y && py <= b.y + b.h && !(b.w > 0.95 && b.h > 0.95);
    drag = { r: r, el: crop.querySelector('.nv-ai__crop-box'), mode: hnd ? hnd.dataset.h : (inside ? 'move' : 'new'),
             sx: px, sy: py, b0: { x: b.x, y: b.y, w: b.w, h: b.h }, moved: false, id: e.pointerId };
    try { crop.setPointerCapture(e.pointerId); } catch (er) {}
  });
  body.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var px = clamp((e.clientX - drag.r.left) / drag.r.width), py = clamp((e.clientY - drag.r.top) / drag.r.height);
    var dx = px - drag.sx, dy = py - drag.sy, b0 = drag.b0, M = 0.08, b;
    if (!drag.moved && Math.abs(dx) + Math.abs(dy) < 0.012) return;
    drag.moved = true;
    if (drag.mode === 'move') b = { x: clamp(b0.x + dx, 0, 1 - b0.w), y: clamp(b0.y + dy, 0, 1 - b0.h), w: b0.w, h: b0.h };
    else if (drag.mode === 'new') b = { x: Math.min(px, drag.sx), y: Math.min(py, drag.sy), w: Math.abs(dx), h: Math.abs(dy) };
    else {
      var x1 = b0.x, y1 = b0.y, x2 = b0.x + b0.w, y2 = b0.y + b0.h;
      if (drag.mode.charAt(1) === 'w') x1 = Math.min(px, x2 - M); else x2 = Math.max(px, x1 + M);
      if (drag.mode.charAt(0) === 'n') y1 = Math.min(py, y2 - M); else y2 = Math.max(py, y1 + M);
      b = { x: x1, y: y1, w: x2 - x1, h: y2 - y1 };
    }
    photo.box = b; if (drag.el) drag.el.style.cssText = boxStyle(b);
  });
  function endDrag(e) {
    if (!drag || (e && e.pointerId !== drag.id)) return;
    var d = drag; drag = null;
    if (!d.moved) return;
    var b = photo.box;
    if (b.w < 0.08 || b.h < 0.08) { photo.box = d.b0; if (d.el) d.el.style.cssText = boxStyle(d.b0); return; } // riquadro troppo piccolo
    clearTimeout(cropTimer); cropTimer = setTimeout(recrop, 120);
  }
  body.addEventListener('pointerup', endDrag);
  body.addEventListener('pointercancel', endDrag);

  // foto incollata (Ctrl+V / Cmd+V) mentre la finestra è aperta
  document.addEventListener('paste', function (e) {
    if (!root.classList.contains('is-open')) return;
    var items = (e.clipboardData && e.clipboardData.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].kind === 'file' && /^image\//.test(items[i].type)) {
        var f = items[i].getAsFile();
        if (f) { e.preventDefault(); track('ai_photo_paste', {}); searchImage(f); return; }
      }
    }
  });
  // foto trascinata sulla finestra (computer)
  var dragDepth = 0;
  function hasFiles(e) { var t = e.dataTransfer && e.dataTransfer.types; return !!t && Array.prototype.indexOf.call(t, 'Files') > -1; }
  root.addEventListener('dragenter', function (e) { if (!hasFiles(e)) return; e.preventDefault(); dragDepth++; root.classList.add('is-drop'); });
  root.addEventListener('dragover', function (e) { if (!hasFiles(e)) return; e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; });
  root.addEventListener('dragleave', function (e) { if (!hasFiles(e)) return; if (--dragDepth <= 0) { dragDepth = 0; root.classList.remove('is-drop'); } });
  root.addEventListener('drop', function (e) {
    if (!hasFiles(e)) return;
    e.preventDefault(); dragDepth = 0; root.classList.remove('is-drop');
    var f = Array.prototype.filter.call(e.dataTransfer.files || [], function (x) { return /^image\//.test(x.type); })[0];
    if (f) { track('ai_photo_drop', {}); searchImage(f); }
  });
  function track(name, params) { try { if (window.gtag) window.gtag('event', name, params); } catch (e) {} }

  // --- suggerimenti mentre si scrive ---
  var acTimer, acReq = 0, acActive = -1, acCache = {};
  function closeAc() { root.classList.remove('is-typing'); ac.classList.remove('is-open'); ac.innerHTML = ''; acActive = -1; q.setAttribute('aria-expanded', 'false'); }
  function hl(text, typed) {
    var t = esc(text), i = text.toLowerCase().indexOf(typed.toLowerCase());
    if (!typed || i < 0) return t;
    return esc(text.slice(0, i)) + '<b>' + esc(text.slice(i, i + typed.length)) + '</b>' + esc(text.slice(i + typed.length));
  }
  function renderAc(d, typed) {
    var qs = d.queries || [], ps = d.products || [], html = '';
    html += '<ul class="nv-ai__ac-list">' +
      '<li class="nv-ai__ac-item nv-ai__ac-item--ai" role="option" data-acq="' + esc(typed) + '">' + STAR + '<span>Cerca con l\'AI: <b>' + esc(typed) + '</b></span></li>' +
      qs.map(function (s) { return '<li class="nv-ai__ac-item" role="option" data-acq="' + esc(s) + '">' + LENS + '<span>' + hl(s, typed) + '</span></li>'; }).join('') + '</ul>';
    if (ps.length) {
      html += '<ul class="nv-ai__ac-list"><li class="nv-ai__ac-head" aria-hidden="true">Prodotti</li>' + ps.map(function (p) {
        return '<li role="option"><a class="nv-ai__ac-item" href="/products/' + encodeURIComponent(p.handle) + '"><img class="nv-ai__ac-img" loading="lazy" src="' + esc(p.image_small) + '" alt="">' +
          '<span class="nv-ai__ac-txt"><span>' + hl(p.title, typed) + '</span><span class="nv-ai__ac-price' + (p.compare_at ? ' is-sale' : '') + '">' + money(p.price) + (p.vendor ? ' · ' + esc(p.vendor) : '') + '</span></span></a></li>';
      }).join('') + '</ul>';
    }
    ac.innerHTML = html; acActive = -1;
    ac.classList.add('is-open'); root.classList.add('is-typing'); q.setAttribute('aria-expanded', 'true');
  }
  function fetchAc() {
    var typed = q.value.trim();
    if (typed.length < 2) return closeAc();
    var id = ++acReq;
    if (acCache[typed]) return renderAc(acCache[typed], typed);
    fetch(API + '/suggest?q=' + encodeURIComponent(typed)).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      if (!d || id !== acReq || q.value.trim() !== typed || document.activeElement !== q) return;
      acCache[typed] = d; renderAc(d, typed);
    }).catch(function () {});
  }
  function moveAc(step) {
    var items = ac.querySelectorAll('.nv-ai__ac-item');
    if (!items.length) return;
    acActive = (acActive + step + items.length) % items.length;
    items.forEach(function (el, i) { el.classList.toggle('is-active', i === acActive); });
    items[acActive].scrollIntoView({ block: 'nearest' });
  }
  q.addEventListener('input', function () { syncBar(); clearTimeout(acTimer); acTimer = setTimeout(fetchAc, 180); });
  q.addEventListener('focus', function () { if (q.value.trim().length >= 2) fetchAc(); });
  q.addEventListener('keydown', function (e) {
    if (!ac.classList.contains('is-open')) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); moveAc(1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); moveAc(-1); }
    else if (e.key === 'Enter' && acActive > -1) {
      e.preventDefault();
      var el = ac.querySelectorAll('.nv-ai__ac-item')[acActive];
      if (el.dataset.acq != null) { q.value = el.dataset.acq; syncBar(); searchText(el.dataset.acq); } else { var old = curSid; curSid = ''; var eh = decodeURIComponent(el.getAttribute('href').split('/products/')[1] || ''); beacon('ac_product', eh, null, q.value.trim()); curSid = old; remember(eh); location.href = el.href; }
    }
  });
  ac.addEventListener('mousedown', function (e) { e.preventDefault(); }); // il campo non perde il focus
  ac.addEventListener('click', function (e) {
    var it = e.target.closest('[data-acq]');
    if (it) { q.value = it.dataset.acq; syncBar(); searchText(it.dataset.acq); return; }
    var pa = e.target.closest('a.nv-ai__ac-item');
    if (pa) { var ph = decodeURIComponent(pa.getAttribute('href').split('/products/')[1] || ''); var old = curSid; curSid = ''; beacon('ac_product', ph, null, q.value.trim()); curSid = old; remember(ph); }
  });
  q.addEventListener('blur', function () { setTimeout(closeAc, 150); });

  document.getElementById('nv-ai-form').addEventListener('submit', function (e) { e.preventDefault(); acReq++; clearTimeout(acTimer); searchText(q.value.trim()); });
  document.getElementById('nv-ai-photo').addEventListener('click', function () { fileIn.click(); });
  document.getElementById('nv-ai-clear').addEventListener('click', function (e) { e.preventDefault(); acReq++; q.value = ''; syncBar(); closeAc(); q.focus(); });
  fileIn.addEventListener('change', function () { if (fileIn.files[0]) searchImage(fileIn.files[0]); fileIn.value = ''; });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-nv-close]')) return close();
    if (e.target.closest('[data-more]')) return showMore();
    // risposta con pulsante "klaviyo:ID": si chiude la ricerca e si apre il modulo Klaviyo (es. newsletter)
    var klb = e.target.closest('[data-klaviyo]');
    if (klb) {
      var fid = klb.dataset.klaviyo; track('ai_answer_klaviyo', { form: fid }); close();
      setTimeout(function () { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', fid]); }, 350);
      return;
    }
    var ddb = e.target.closest('[data-dd]'); if (ddb) return openPop(ddb);
    var eye = e.target.closest('[data-eye]');
    if (eye) { closePop(); root.classList.toggle('is-compact'); eye.outerHTML = eyeHtml(); track('ai_details', { shown: !root.classList.contains('is-compact') }); beacon('filter', '', null, 'dettagli=' + (root.classList.contains('is-compact') ? 'off' : 'on')); return; }
    var opt = e.target.closest('[data-opt]');
    if (opt && popBtn) {
      var key = popBtn.dataset.dd; fl[key] = opt.dataset.opt || (key === 'sort' ? 'rel' : '');
      closePop(); track('ai_filter', { type: key, value: fl[key] }); beacon('filter', '', null, (FL_KEY[key] || key) + '=' + (fl[key] || 'tutti')); return refilter();
    }
    if (pop && !e.target.closest('.nv-ai__pop')) closePop();
    if (e.target.closest('[data-clear-viewed]')) { LS.set('nvAiViewed', []); var vb = body.querySelector('.nv-ai__viewed'); if (vb) vb.remove(); return; }
    if (e.target.closest('[data-clear-recent]')) { LS.set('nvAiRecent', []); var rb = body.querySelector('.nv-ai__recent'); if (rb) rb.remove(); return; }
    if (e.target.closest('[data-fl-reset]')) { var srt = fl.sort; resetFl(); fl.sort = srt; beacon('filter', '', null, 'azzera'); return refilter(); }
    var exb = e.target.closest('[data-exact]'); if (exb) { q.value = exb.dataset.exact; syncBar(); return searchText(exb.dataset.exact, null, true); }
    if (e.target.closest('[data-crop-reset]') && photo) { photo.box = { x: 0, y: 0, w: 1, h: 1 }; return recrop(); }
    if (e.target.closest('[data-photo-new]')) return fileIn.click();
    var rq = e.target.closest('[data-rq]'); if (rq) { beacon('filter', '', null, 'tipo=' + (rq.dataset.rt || '')); q.value = rq.dataset.rq; syncBar(); return searchText(rq.dataset.rq); }
    var ex = e.target.closest('[data-ex]'); if (ex) { q.value = ex.dataset.ex; syncBar(); return searchText(ex.dataset.ex); }
    var s = e.target.closest('[data-sim]'); if (s) { e.preventDefault(); beacon('similar', s.dataset.sim, posOf(s.dataset.sim)); similar(s.dataset.sim, s.dataset.title); return; }
    var w = e.target.closest('[data-wish]'); if (w) { e.preventDefault(); if (!wished[w.dataset.wish]) beacon('wish', w.dataset.wish, posOf(w.dataset.wish)); toggleWish(w, w.dataset.wish); return; }
    var card = e.target.closest('a.nv-ai__card');
    if (card) { var h = decodeURIComponent(card.getAttribute('href').split('/products/')[1] || ''); beacon('open', h, posOf(h)); remember(h); }
  });
  // tendine dei filtri: si chiudono cliccando fuori, scorrendo o con Esc
  root.addEventListener('scroll', function (e) { if (pop && !pop.contains(e.target) && Date.now() - popAt > 350) closePop(); }, true);
  window.addEventListener('resize', closePop);
  // indietro/avanti del browser
  function restore(st) {
    if (st.q) { open(true); q.value = st.q; syncBar(); searchText(st.q, st.sid, st.exact); }
    else if (st.sim) similar(st.sim, st.title || '', st.sid);
    else open(true);
  }
  window.addEventListener('popstate', function (e) {
    var st = e.state, isOpen = root.classList.contains('is-open') && root.classList.contains('is-visible');
    if (st && st.nvAi) { e.stopImmediatePropagation(); if (!isOpen) restore(st); }
    else if (isOpen) { e.stopImmediatePropagation(); close(true); }
  }, true);
  // tornando indietro da un prodotto aperto dai risultati, la ricerca si riapre com'era
  onReady(function () { if (inAiState() && !root.classList.contains('is-open')) restore(history.state); });
  window.addEventListener('pageshow', function (e) { if (e.persisted && !inAiState() && root.classList.contains('is-open')) close(true); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
    if (pop) { var b = popBtn; closePop(); if (b) b.focus(); return; }
    if (ac.classList.contains('is-open')) closeAc(); else close();
  });

  // --- voce nell'header, PRIMA di "Cerca" ---
  function addTriggers() {
    document.querySelectorAll('a[aria-controls="search-drawer"]').forEach(function (a) {
      if (a.dataset.nvAi) return; a.dataset.nvAi = '1';
      var desktop = a.classList.contains('with-text');
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', 'Ricerca AI');
      b.className = 'nv-ai-trigger tap-area' + (desktop ? ' with-text bold link-faded-reverse' : '');
      b.innerHTML = STAR_LINE + (desktop ? '<span>Ricerca AI</span>' : '');
      b.addEventListener('click', open);
      var holder = a.closest('.mobile-search') || a;
      holder.insertAdjacentElement('beforebegin', b);
    });
  }
  function onReady(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  onReady(addTriggers);
  document.addEventListener('shopify:section:load', addTriggers);
  window.nvAiSearch = { open: open, similar: similar };

  if (CFG.product) {
  // --- scheda prodotto: "Trova simili" sulla prima foto e prodotti visti ---
  onReady(function () {
    var handle = CFG.product.h, title = CFG.product.t;
    CURRENT = handle;
    // visti di recente (per la finestra della Ricerca AI)
    var img = CFG.product.i;
    if (img) LS.set('nvAiViewed', [{ h: handle, t: title, i: img }].concat(LS.get('nvAiViewed').filter(function (v) { return v && v.h !== handle; })).slice(0, 9));

    var first = document.querySelector('product-gallery .product-gallery__media, .product-gallery__media');
    if (first && !first.querySelector('.nv-ai-gallery-btn')) {
      first.classList.add('nv-ai-has-btn');
      var wrap = document.createElement('div');
      wrap.innerHTML = simButton('nv-ai__sim--light nv-ai-gallery-btn');
      var b = wrap.firstChild;
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); similar(handle, title); });
      first.appendChild(b);
    }
  });
  }
})();
